<template>
    <div>
        <div class="export-hidden">
            <div class="export-this p-4">
                <!-- Header -->
                <div class="d-flex align-items-center" :style="{ gap: '20px'}">
                    <img class="mb-3" src="/imgs/logoAbelhaRainha.png" :style="{ width: '220px' }"/>
    
                    <el-card class="mb-3 flex-grow-1">
                        <div class="d-flex justify-content-between">
                            <div class="d-flex align-items-center">
                                <el-tag type="info" class="mr-2">
                                    <i class="el-icon-notebook-1"></i>
                                </el-tag>
                                <div v-if="userScheduleName" class="d-flex align-items-center" :style="{ gap: '12px' }">
                                    <h5 class="mb-0 font-weight-semibold">Agenda: </h5>
                                    <div class="d-flex align-items-center" :style="{ gap: '4px' }">
                                        <el-avatar size="small">{{ scheduleUserName.charAt(0) }}</el-avatar>
                                        <h6 class="mb-0 text-capitalize">{{ scheduleUserName.toLowerCase() }}</h6>
                                    </div>
                                </div>
                                <h5 v-else class="font-weight-semibold mb-0">Minha Agenda</h5>
                            </div>
    
                            <h5 v-if="date" class="font-weight-semibold mb-0">{{ date }}</h5>
                        </div>
                    </el-card>
                </div>
    
                <el-row :gutter="20">
                    <el-col>
                        <el-card>
                            <!-- Calendar -->
                            <slot name="calendar"></slot>
    
                            <!-- Status -->
                            <div v-if="status.length > 0" class="d-flex align-items-center mt-3">
                                <h6 class="mb-0 mr-2">Status:</h6> 
                                <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                                    <el-tag 
                                        v-for="(stat) in status"
                                        :key="stat.value"
                                        :type="getEventColorByStatus(stat.value)"
                                        class="rounded-pill"
                                    >
                                        {{ stat.text }}
                                    </el-tag>
                                </div>
                            </div>

                            <!-- Despesas -->
                            <div v-if="despesas.length > 0" class="d-flex align-items-center mt-3">
                                <h6 class="mb-0 mr-2">Despesas:</h6> 
                                <div 
                                    class="d-flex align-items-center"
                                    :style="{ gap: '8px' }"
                                >
                                    <div 
                                        v-for="(des) in despesas"
                                        class="border rounded py-1 px-2"
                                    >
                                        <i :class="des.icon"/>
                                        <span class="ml-1">{{ des.text }}</span>
                                    </div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>

</template>
<script>
    // pdf
    import html2canvas from "html2canvas";
    import jsPDF from "jspdf";
    
    import {
        Card,
        Row,
        Col,
        Notification,
        Tag,
        Avatar,
    } from 'element-ui'

    export default {
        props: {
            date: {
                type: String,
                default: null
            },
            userScheduleName: {
                type: [String, null],
                default: null
            },
            status: {
                type: Array,
                default: () => []
            },
            despesas: {
                type: Array,
                default: () => []
            },
        },  
        data() {
            return {
                isLoading: false,
            }
        },
        methods: {
            async exportarAgendaParaPdf() {

                await this.$nextTick()

                const elLoading = this.$loading({ lock: true, text: "Gerando PDF..." });

                try {
                    const el = this.$el.querySelector(".export-this");

                    const canvas = await html2canvas(el, {
                        scale: 2, // melhora a resolução
                        useCORS: true,
                        // Importante: já que o elemento está fora da tela (left: -9999px),
                        // o html2canvas por padrão captura baseado no scroll/posição do elemento.
                        // Forçar as coordenadas de captura evita problemas de recorte:
                        x: 0,
                        y: 0,
                        scrollX: 0,
                        scrollY: 0,
                        windowWidth: el.scrollWidth,
                        windowHeight: el.scrollHeight,
                    });

                    const imgData = canvas.toDataURL("image/png");

                    // A4 em mm
                    const pdf = new jsPDF("p", "mm", "a4");
                    const pageWidth = pdf.internal.pageSize.getWidth();
                    const pageHeight = pdf.internal.pageSize.getHeight();

                    const imgWidth = pageWidth;
                    const imgHeight = (canvas.height * imgWidth) / canvas.width;

                    let heightLeft = imgHeight;
                    let position = 0;

                    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
                    heightLeft -= pageHeight;

                    // Quebra em múltiplas páginas se o calendário for maior que uma folha A4
                    while (heightLeft > 0) {
                        position = heightLeft - imgHeight;
                        pdf.addPage();
                        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
                        heightLeft -= pageHeight;
                    }

                    pdf.save("agenda.pdf");
                } catch (err) {
                    console.log(err);
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi exportar a agenda! Algo inesperado ocorreu'
                    });
                } finally {
                    elLoading.close();
                }
            },
            getEventColorByStatus(status) {
                switch(status) {
                    case 'APROVADO':
                        return 'success'
                    case 'PENDENTE':
                        return 'warning'
                    case 'CUMPRIDO':
                        return ''
                    case 'NAO CUMPRIU':
                        return 'danger'
                    case 'REPROVADO':
                        return 'info'
                    default: 
                        return 'info'
                }
            },
        },
        computed: {
            scheduleUserName() {
                if (this.userScheduleName == null) {
                    return null
                }

                return this.userScheduleName.split('-')[1].trim();
            }
        },
        components: {
            [Card.name]: Card,
            [Row.name]: Row,
            [Col.name]: Col,
            [Notification.name]: Notification,
            [Tag.name]: Tag,
            [Avatar.name]: Avatar,
        }
    }
</script>
<style scoped>
    .export-hidden {
        min-width: 1066px;
        position: fixed;
        top: 0;
        left: -9999px; /* joga pra fora da tela, mas mantém renderizado */
        z-index: -1;
        pointer-events: none; /* evita que o usuário interaja acidentalmente */
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/agenda/EventsExportToPdf.vue